import React from 'react';

import './index.scss';

export default class extends React.Component {
    state = {}

    render() {
        const { type, contentText, buttonLeftText, buttonRightText, buttonLeftClick, buttonRightClick } = this.props;
        return (
            <div className='device-bind-medal'>
                <div className='device-bind-content'>
                    <div className={type && type === 'bind' ? 'device-bind-tao bind' : 'device-bind-tao'} />
                    <div className='device-bind-text'>{contentText}</div>
                    <div className='device-bind-bottom'>
                        <div className='device-bind-left' onClick={() => { buttonLeftClick && buttonLeftClick(); }}>{buttonLeftText}</div>
                        <div className='device-bind-right' onClick={() => { buttonRightClick && buttonRightClick(); }}>{buttonRightText}</div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Device/DeviceBindDialog.js